/**
 * Styled components for PolicyCanvas
 */

import styled from 'styled-components';
import { Box } from '@usealloy/component-library';

/**
 * Main container for the canvas component
 */
export const CanvasContainer = styled(Box)`
  flex: 1 0 auto;
  height: 100%;
  width: 100%;
  position: relative;
`;

/**
 * Scrollable wrapper for the canvas
 */
export const ScrollableWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
`;

/**
 * Inner canvas container with dynamic sizing
 */
export const CanvasInner = styled.div<{ width: number; height: number }>`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  min-width: 100%;
  min-height: 100%;
  position: relative;
`;

/**
 * React Flow container
 */
export const FlowContainer = styled.div`
  width: 100%;
  height: 100%;
`;

